import React, { useContext, useState } from 'react'
import ReactReadMoreReadLess from "react-read-more-read-less";
import { RaiseRequestContext } from '../../Contexts/RaiseRequestContext';
import useModule from '../../hooks/useModule';
import { descriptionCharLimit } from '../../Config/config';
import { matchPath, useLocation } from 'react-router';
import routePathSegments from '../../routeSegments';
import { UserContext } from '../../Contexts/UserContext';

const DealMoreInfo = (props) => {
    const [activeOption, setActiveOption] = useState('dealDetails');
    const { isMA } = useModule();
    const { openRequestPopup } = useContext(RaiseRequestContext)
    const { getHideValuationFlag } = useContext(UserContext);
    const location = useLocation();
    const isPeMatch = matchPath(`${routePathSegments.pe}/*`, location.pathname)

    let dealDetailsText =
        props?.page == "dealPage"
        ? props?.data?.moreInformation : props?.page == "madealPage" ?
            props?.data?.deal_details
            : props?.data?.business_desc
    
    let dealStructureText = props?.data?.deal_structure || "";
    
    const charLength = descriptionCharLimit;

    const component = "moreInfoInvestment" 
    
    // Determine which text to display based on the active option
    const displayText = activeOption === 'dealDetails' ? dealDetailsText : dealStructureText;
    
    const shouldShowTabs = (
        props?.activeTab == "investments" && props.page !== "dealStructure" ||
        props?.activeTab == "incubations" ||
        props?.activeTab == "angels" ||
        props?.activeTab == "exits" ||
        props?.page == "madealPage"
    );

    const shouldShowIpoStructure = !(
        props?.page == "companyPage" || 
        props?.page == "reCompanyPage" || 
        props.page === "fillingsPage" || 
        props.page == "dealStructure"
    ) && !shouldShowTabs;

    return (
        <div className={`${props.page === "dealStructure" ? "px-1" : "px-2"}`}>
            {(dealDetailsText != "" || dealStructureText != "") ? (
            <>
                {shouldShowTabs && (dealDetailsText !== "" || dealStructureText !== "") ? (
                    <div className="mx-3 flex">
                        <p 
                            className={`mr-12 mb-2 cursor-pointer ${activeOption === 'dealDetails' 
                                ? 'text-[14pt] lg:text-[17px] text-[#333333] leading-[19pt] font-semibold lg:leading-[22px]' 
                                : 'text-base text-[#838383] leading-[19pt] font-semibold lg:leading-[22px]'}`}
                            onClick={() => setActiveOption('dealDetails')}
                        >
                            Deal Details
                        </p>
                        {!getHideValuationFlag() && dealStructureText !== "" && (
                            <p 
                                className={`cursor-pointer ${activeOption === 'dealStructure' 
                                    ? 'text-[14pt] lg:text-[17px] text-[#333333] leading-[19pt] font-semibold lg:leading-[22px]' 
                                    : 'text-base text-[#838383] leading-[19pt] font-semibold lg:leading-[22px]'}`}
                                onClick={() => setActiveOption('dealStructure')}
                            >
                                Deal Structure
                            </p>
                        )}
                    </div>
                ) : shouldShowIpoStructure ? (
                    <p className="mx-3 text-[14pt] leading-[18pt] lg:text-[17px] text-[#333333] font-semibold lg:leading-[22px]">
                        Ipo Structure:
                    </p>
                ) : null}
                
                <p className={`${props.page === "dealStructure" ? "" : "mt-2 py-1 mx-3"} whitespace-pre-line text-[11pt] leading-[18pt] lg:text-[14px] text-[#333333] lg:leading-[20px]`}>
                    {displayText ?? ""}
                
                    {props?.page == "companyPage" || props?.page == "reCompanyPage" || props.page == "dealStructure" ? (
                        " "
                    ) : (
                        <p className="mt-6">
                        {activeOption === 'dealDetails' && (
                            props?.activeTab == "investments" ?
                                <>
                                <button className='text-[#A5711A] hover:underline' onClick={() => openRequestPopup(isMA ? 'mandaDealAdvisorInfo': component)}>Request more information</button>&nbsp;
                                specifying what details you would like. Note: For recent transactions, regulatory filing based information is typically less than that for older ones.
                                </>
                                : props?.activeTab == "incubations" || props?.activeTab == 'ipos' ?
                                <>
                                    <button className='text-[#A5711A] hover:underline' onClick={() => openRequestPopup(isMA ? 'mandaDealAdvisorInfo': component)}>Click Here</button>&nbsp;
                                    to request more details for this deal.
                                </>
                                : props?.activeTab == 'exits' ?
                                    <>
                                    <button className='text-[#A5711A] hover:underline' onClick={() => openRequestPopup(isMA ? 'mandaDealAdvisorInfo': component)}>Request more information</button>&nbsp;
                                    specifying what details you would like.
                                    </>
                                    : props?.activeTab == "angels" ?
                                    <>
                                        <button className='text-[#A5711A] hover:underline' onClick={() => openRequestPopup(isMA ? 'mandaDealAdvisorInfo': component)}>Click Here</button>&nbsp;
                                        to request more details (financials, valuations, etc.) to the extent available for this deal.
                                    </>
                                    :
                                    <>
                                        <button className='text-[#A5711A] hover:underline' onClick={() => openRequestPopup(isMA ? 'mandaDealAdvisorInfo': component)}>Request more information</button>&nbsp;
                                        specifying what details you would like. Note: For recent transactions, regulatory filing based information is typically less than that for older ones.
                                    </>
                            )
                        }</p>
                    )}
                </p>
            </>
            )
            :
            ""
            }
        </div>
    )
}

export default DealMoreInfo